module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/header_pc_4cc64960b8b46707d631e86a18dbd769.jpg";